import axios from '@/utils/request'

export default {
  getConfig(params) {
    return new Promise((resolve, reject) => {
      axios.get('/live/config', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCode(params) {
    return new Promise((resolve, reject) => {
      axios.post('/sms/code', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  codeLogin(params) {
    return new Promise((resolve, reject) => {
      axios.post('/login', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getRefreshLogin(params) {
    return new Promise((resolve, reject) => {
      axios.post('/refresh_login', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getUserList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/user/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getUserInfo(params) {
    return new Promise((resolve, reject) => {
      axios.get('/user/info', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addUser(params) {
    return new Promise((resolve, reject) => {
      axios.post('/user/add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  updateUser(params) {
    return new Promise((resolve, reject) => {
      axios.post('/user/update', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addUserIntegral(params) {
    return new Promise((resolve, reject) => {
      axios.post('/user/integral-add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },

  passwordUser(params) {
    return new Promise((resolve, reject) => {
      axios.post('/user/password', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  disableUser(params) {
    return new Promise((resolve, reject) => {
      axios.post('/user/disable', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getLineList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/line/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getLineLogList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/line/log', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addLine(params) {
    return new Promise((resolve, reject) => {
      axios.post('/line/add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  updateLine(params) {
    return new Promise((resolve, reject) => {
      axios.post('/line/update', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getLiveList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/live/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getProductList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/product/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addProduct(params) {
    return new Promise((resolve, reject) => {
      axios.post('/product/add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  updateProduct(params) {
    return new Promise((resolve, reject) => {
      axios.post('/product/update', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCompanyList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/company/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCompanyInfo(params) {
    return new Promise((resolve, reject) => {
      axios.get('/company/info', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  toCompanyVerify(params) {
    return new Promise((resolve, reject) => {
      axios.put('/company/verify', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },


  getGuideConfig(params) {
    return new Promise((resolve, reject) => {
      axios.get('/live/guide-config', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  updateGuideConfig(params) {
    return new Promise((resolve, reject) => {
      axios.post('/live/guide-config-update', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getOrderListData(params) {
    return new Promise((resolve, reject) => {
      axios.get('/shop/order', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },


  getPlatformList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/shortvideo/platform-list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  editPlatform(id, params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/platform-edit/' + id, params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },

  getAccountList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/shortvideo/account-list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addAccount(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/account-add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  editAccount(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/account-edit', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  delAccount(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/account-del', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },

  getTokenList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/shortvideo/token-list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  addToken(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/token-add', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  editToken(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/token-edit', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  delToken(params) {
    return new Promise((resolve, reject) => {
      axios.put('/shortvideo/token-del', params)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCensusUserDay(params) {
    return new Promise((resolve, reject) => {
      axios.get('/census/user-day', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCensusModelDay(params) {
    return new Promise((resolve, reject) => {
      axios.get('/census/model-day', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getCensusModelList() {
    return new Promise((resolve, reject) => {
      axios.get('/census/model-list')
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },

  getBillList(params) {
    return new Promise((resolve, reject) => {
      axios.get('/bill/list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getUserApiBill(params) {
    return new Promise((resolve, reject) => {
      axios.get('/bill/api-list', { params: params })
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  generateSrApiToken(params) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      for (const key in params) {
        formData.append(key, params[key])
      }
      axios.post('/user/sr-api-token', formData)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  updateSrDiscount(params) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      for (const key in params) {
        formData.append(key, params[key])
      }
      axios.post('/user/sr-discount', formData)
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
  getUserAuth() {
    return new Promise((resolve, reject) => {
      axios.get('/info')
        .then((response) => {
          resolve(response)
        })
    }, err => {
      reject(err)
    })
  },
}